export const defaultTotalRow = { category: "Garment Total", value: 0, id: new Date().valueOf() };

export const checkForTotalColumn = (row) => {
	if (row?.["category"] === "Garment Total") return true;
	return false;
};
